import type { VistaDaFace } from "./vistas";

// Catálogo das regiões anatômicas do modo Face. Os contornos são polígonos normalizados (0–1) no
// quadro do desenho. Região lateral: o contorno da frente é o do lado direito do paciente (à esquerda
// de quem olha) e o do perfil é o do perfil direito; o lado esquerdo sai do espelho. A ordem importa:
// a primeira região que contém o ponto vence, então as pequenas vêm antes das grandes.

type Forma = [number, number][];
export type LadoDaRegiao = "D" | "E" | "C";

type Definicao = { base: string; nome: string; lateral: boolean; frente?: Forma; perfil?: Forma };

const DEFINICOES: Definicao[] = [
  { base: "COMISSURA", nome: "Comissura", lateral: true,
    frente: [[0.34, 0.562], [0.385, 0.558], [0.4, 0.598], [0.36, 0.608]],
    perfil: [[0.775, 0.532], [0.815, 0.535], [0.815, 0.565], [0.775, 0.565]] },
  { base: "SULCO_NASOGENIANO", nome: "Sulco nasogeniano", lateral: true,
    frente: [[0.395, 0.488], [0.43, 0.505], [0.39, 0.558], [0.345, 0.556]],
    perfil: [[0.8, 0.46], [0.845, 0.475], [0.82, 0.532], [0.77, 0.53]] },
  { base: "CODIGO_DE_BARRAS", nome: "Perioral (código de barras)", lateral: false,
    frente: [[0.43, 0.515], [0.57, 0.515], [0.6, 0.545], [0.4, 0.545]],
    perfil: [[0.85, 0.485], [0.915, 0.49], [0.905, 0.522], [0.845, 0.52]] },
  { base: "LABIO_SUPERIOR", nome: "Lábio superior", lateral: false,
    frente: [[0.39, 0.545], [0.61, 0.545], [0.625, 0.578], [0.375, 0.578]],
    perfil: [[0.815, 0.52], [0.905, 0.522], [0.9, 0.548], [0.815, 0.548]] },
  { base: "LABIO_INFERIOR", nome: "Lábio inferior", lateral: false,
    frente: [[0.4, 0.578], [0.6, 0.578], [0.575, 0.622], [0.425, 0.622]],
    perfil: [[0.815, 0.548], [0.895, 0.55], [0.88, 0.588], [0.815, 0.585]] },
  { base: "OLHEIRA", nome: "Olheira", lateral: true,
    frente: [[0.26, 0.388], [0.42, 0.388], [0.4, 0.425], [0.28, 0.425]],
    perfil: [[0.72, 0.372], [0.84, 0.372], [0.84, 0.405], [0.73, 0.405]] },
  { base: "PES_DE_GALINHA", nome: "Pés de galinha", lateral: true,
    frente: [[0.165, 0.33], [0.25, 0.33], [0.255, 0.39], [0.175, 0.405]],
    perfil: [[0.64, 0.32], [0.72, 0.325], [0.725, 0.39], [0.65, 0.395]] },
  { base: "GLABELA", nome: "Glabela", lateral: false,
    frente: [[0.43, 0.27], [0.57, 0.27], [0.56, 0.355], [0.44, 0.355]],
    perfil: [[0.845, 0.275], [0.905, 0.275], [0.9, 0.345], [0.85, 0.345]] },
  { base: "NARIZ", nome: "Nariz", lateral: false,
    frente: [[0.445, 0.355], [0.555, 0.355], [0.6, 0.47], [0.59, 0.515], [0.41, 0.515], [0.4, 0.47]],
    perfil: [[0.85, 0.345], [0.9, 0.36], [0.99, 0.445], [0.97, 0.485], [0.85, 0.485], [0.835, 0.43]] },
  { base: "MALAR", nome: "Malar", lateral: true,
    frente: [[0.185, 0.405], [0.29, 0.425], [0.36, 0.45], [0.38, 0.488], [0.3, 0.51], [0.205, 0.495]],
    perfil: [[0.62, 0.395], [0.73, 0.405], [0.835, 0.41], [0.8, 0.46], [0.68, 0.49], [0.6, 0.47]] },
  { base: "MASSETER", nome: "Masseter", lateral: true,
    frente: [[0.195, 0.495], [0.28, 0.51], [0.3, 0.575], [0.235, 0.59], [0.205, 0.55]],
    perfil: [[0.44, 0.5], [0.6, 0.47], [0.66, 0.53], [0.62, 0.61], [0.49, 0.59]] },
  { base: "MANDIBULA", nome: "Linha mandibular", lateral: true,
    frente: [[0.2, 0.55], [0.235, 0.55], [0.27, 0.6], [0.35, 0.655], [0.43, 0.688], [0.43, 0.712], [0.33, 0.68], [0.24, 0.615], [0.205, 0.575]],
    perfil: [[0.42, 0.5], [0.46, 0.51], [0.49, 0.59], [0.62, 0.635], [0.8, 0.66], [0.82, 0.69], [0.62, 0.68], [0.45, 0.62]] },
  { base: "MENTO", nome: "Mento", lateral: false,
    frente: [[0.42, 0.632], [0.58, 0.632], [0.6, 0.69], [0.5, 0.715], [0.4, 0.69]],
    perfil: [[0.8, 0.588], [0.88, 0.59], [0.9, 0.64], [0.85, 0.672], [0.8, 0.665]] },
  { base: "TEMPORA", nome: "Têmpora", lateral: true,
    frente: [[0.15, 0.2], [0.225, 0.19], [0.235, 0.29], [0.2, 0.33], [0.155, 0.325]],
    perfil: [[0.56, 0.2], [0.68, 0.19], [0.66, 0.31], [0.63, 0.36], [0.55, 0.33]] },
  { base: "TESTA", nome: "Testa", lateral: false,
    frente: [[0.24, 0.12], [0.76, 0.12], [0.84, 0.24], [0.6, 0.27], [0.4, 0.27], [0.16, 0.24]],
    perfil: [[0.68, 0.11], [0.84, 0.13], [0.9, 0.2], [0.905, 0.275], [0.8, 0.28], [0.69, 0.27]] },
];

export type RegiaoDaFace = {
  codigo: string;
  nome: string;
  /** Nome com o lado ("Malar D"). */
  rotulo: string;
  base: string;
  lado: LadoDaRegiao;
  par: string | null;
  contornos: Partial<Record<VistaDaFace, Forma>>;
};

const espelho = (f: Forma): Forma => f.map(([x, y]) => [1 - x, y]);

function montar(): RegiaoDaFace[] {
  const lista: RegiaoDaFace[] = [];
  for (const d of DEFINICOES) {
    if (!d.lateral) {
      const contornos: RegiaoDaFace["contornos"] = {};
      if (d.frente) contornos.FRENTE = d.frente;
      if (d.perfil) {
        contornos.PERFIL_DIREITO = d.perfil;
        contornos.PERFIL_ESQUERDO = espelho(d.perfil);
      }
      lista.push({ codigo: d.base, nome: d.nome, rotulo: d.nome, base: d.base, lado: "C", par: null, contornos });
      continue;
    }
    for (const lado of ["D", "E"] as const) {
      const contornos: RegiaoDaFace["contornos"] = {};
      if (d.frente) contornos.FRENTE = lado === "D" ? d.frente : espelho(d.frente);
      if (d.perfil) contornos[lado === "D" ? "PERFIL_DIREITO" : "PERFIL_ESQUERDO"] = lado === "D" ? d.perfil : espelho(d.perfil);
      lista.push({
        codigo: `${d.base}_${lado}`,
        nome: d.nome,
        rotulo: `${d.nome} ${lado}`,
        base: d.base,
        lado,
        par: `${d.base}_${lado === "D" ? "E" : "D"}`,
        contornos,
      });
    }
  }
  return lista;
}

export const REGIOES_DA_FACE: RegiaoDaFace[] = montar();
const POR_CODIGO = new Map(REGIOES_DA_FACE.map((r) => [r.codigo, r]));

export const regiaoDaFace = (codigo: string | null | undefined) => (codigo ? POR_CODIGO.get(codigo) ?? null : null);

function dentro([x, y]: [number, number], forma: Forma) {
  let ok = false;
  for (let i = 0, j = forma.length - 1; i < forma.length; j = i++) {
    const [xi, yi] = forma[i];
    const [xj, yj] = forma[j];
    if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) ok = !ok;
  }
  return ok;
}

/** Região sob o ponto nessa vista — `null` quando cai fora de todas (aí o usuário escolhe). */
export function regiaoNoPonto(vista: VistaDaFace, x: number, y: number): RegiaoDaFace | null {
  for (const r of REGIOES_DA_FACE) {
    const forma = r.contornos[vista];
    if (forma && dentro([x, y], forma)) return r;
  }
  return null;
}

/** Regiões que aparecem nessa vista, pra escolha manual. */
export const regioesDaVista = (vista: VistaDaFace) => REGIOES_DA_FACE.filter((r) => r.contornos[vista]);

export const regiaoEspelhada = (codigo: string | null | undefined) => {
  const r = regiaoDaFace(codigo);
  return r ? (r.par ?? r.codigo) : null;
};
